<template>
  <div>
    <div class="button cta success" @click="invoiceModal.showModal = true">Create Invoice</div>

    <div class="list-box">
      <table>
        <thead>
          <th>ID</th>
          <th>Invoice Start Date</th>
          <th>Invoice End Date</th>
          <th>Due Date</th>
          <th>Status</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="invoice in invoices" v-show="invoices.length > 0" :key="invoice.id">
            <td class="id">{{invoice.id}}</td>
            <td>{{ invoice.startDate }}</td>
            <td>{{ invoice.endDate }}</td>
            <td>{{ invoice.dueDate }}</td>
            <td><span :class="['status', invoice.status]">{{ invoice.status }}</span></td>
            <td><a class="button cta xsmall" target="_blank"
              :href="'/#/corporate/' + corporateId + '/invoice/' + invoice.id">View</a></td>
          </tr>

          <tr v-show="loading">
            <td colspan="6" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              Getting your invoices...
            </td>
          </tr>

          <tr v-show="invoices.length === 0 && !loading">
            <td colspan="6" class="table-block">No Invoices as of yet.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards-mobile">
      <div v-show="loading"></div>
      <div v-show="invoices.length === 0 && !loading"></div>
      <div class="card" v-for="invoice in invoices" v-show="invoices.length > 0" :key="invoice.id">
        <div class="title">
          <div class="label">Invoice ID: </div>
          <div class="value">{{invoice.id}}</div>
        </div>
        <div class="title">
          <div class="label">Invoice Start Date: </div>
          <div class="value">{{invoice.startDate}}</div>
        </div>
        <div class="title">
          <div class="label">Invoice End Date: </div>
          <div class="value">{{invoice.endDate}}</div>
        </div>
        <div class="title">
          <div class="label">Invoice Due Date: </div>
          <div class="value">{{invoice.dueDate}}</div>
        </div>
        <div class="title">
          <div class="label">Status: </div>
          <div :class="['value status', invoice.status]">{{invoice.status}}</div>
        </div>
        <div class="btn-action">
          <a class="button cta xsmall" target="_blank"
          :href="'/#/corporate/' + corporateId + '/invoice/' + invoice.id">View</a>
        </div>
      </div>
    </div>

    <div :class="{'modal':true, 'show':invoiceModal.showModal}">
      <div class="bg-overlay" @click="closeInvoice"></div>
      <div class="modal-content invoice-box">
        <div class="header">Create Invoice</div>

        <div class="row">
          <div class="column medium-6 padding-R-s">
            <div class="data-field">
              <div class="label">Date Coverage From</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoiceModal.error.dateFrom}"
                v-model="invoiceModal.dateFrom" :disabled-picker="invoiceLoading"
                :input-class="{'datepicker-empty':invoiceModal.error.dateFrom}"
                :disabled="dateMaxYesterday"></datepicker>
              <span class="error-msg">{{ invoiceModal.error.dateFrom }}</span>
            </div>
          </div>

          <div class="column medium-6 padding-L-s">
            <div class="data-field">
              <div class="label">Date Coverage To</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoiceModal.error.dateTo}"
                v-model="invoiceModal.dateTo" :disabled-picker="invoiceLoading"
                :input-class="{'datepicker-empty':invoiceModal.error.dateTo}"
                :disabled="dateMaxYesterday"></datepicker>
              <span class="error-msg">{{ invoiceModal.error.dateTo }}</span>
            </div>
          </div>

          <div class="column medium-12">
            <div class="data-field">
              <div class="label">Payment Due Date</div>
              <datepicker :format="calendarFormat"
                :class="{'datepicker inline':true, 'has-error':!!invoiceModal.error.dueDate}"
                v-model="invoiceModal.dueDate" :disabled-picker="invoiceLoading"
                :input-class="{'datepicker-empty':invoiceModal.error.dueDate}"
                :disabled="disabledDueDate"></datepicker>
              <span class="error-msg">{{ invoiceModal.error.dueDate }}</span>
            </div>
          </div>
        </div>

        <div class="has-error" v-show="invoiceModal.showZeroResults">Empty result.</div>
        <button :class="{'button cta block small':true, 'disabled':invoiceLoading}" @click="createInvoice">
          <span v-if="!invoiceLoading">Create</span>
          <span v-else>Loading...</span>
        </button>
        <span class="close" @click="closeInvoice">Close</span>
      </div>
    </div>

    <invoice-pdf ref="invoice" @zeroResults="zeroResults" @refresh="createInvoiceSuccess"></invoice-pdf>

    <transition name="expand">
      <div class="respond-box" v-if="respond.show">
        <div class="vertical-center">
          <div class="card ">
            <div class="success">
              <i class="fas fa-check-circle" v-if="respond.success"></i>
              <i class="fas fa-times-circle" v-else></i>
              <div class="label">{{ respond.label }}</div>
              <div class="message" v-if="!!respond.message" v-html="respond.message"></div>
            </div>
            <div class="button cta block small margin-T-l" @click="closeRespondModal">Close</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import ApiInvoice from '@/modules/api/corporate/invoice'
import invoicePDF from './InvoicePDF'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'invoice-list',
  data () {
    return {
      invoiceModal: {
        showModal: false,
        dueDate: moment().format(),
        dateFrom: '',
        dateTo: '',
        error: {
          dueDate: '',
          dateFrom: '',
          dateTo: ''
        },
        showZeroResults: false,
        loading: false
      },
      today: moment(),
      respond: {
        show: false,
        success: false,
        label: '',
        message: ''
      },
      loading: false
    }
  },
  components: { datepicker, 'invoice-pdf': invoicePDF },
  computed: {
    corporateId () { return this.$route.params.id },
    conId () { return this.$store.state.corporate.profile.info.consId },
    invoices () { return this.$store.state.corporate.invoice.list },
    dateMaxYesterday () {
      let x = this.today.clone()
      if (x.format('MM') === '01') {
        return {
          from: new Date(
            x.subtract(1, 'months').format('YYYY'),
            x.format('MM'),
            x.format('DD')
          )
        }
      }

      return {
        from: new Date(
          x.format('YYYY'),
          x.subtract(1, 'months').format('MM'),
          x.format('DD')
        )
      }
    },
    disabledDueDate () {
      let x = this.today.clone()
      if (x.format('MM') === '01') {
        return {
          to: new Date(
            x.subtract(1, 'months').format('YYYY'),
            x.format('MM'),
            x.format('DD')
          )
        }
      }

      return {
        to: new Date(
          x.format('YYYY'),
          x.subtract(1, 'months').format('MM'),
          x.format('DD')
        )
      }
    },
    invoiceLoading () { return this.$store.state.corporate.invoice.formLoading },
  },
  methods: {
    init () {
      this.$store.commit('corporate/resetInvoice')
      this.$store.commit('corporate/setInvoiceMaxList', false)
      this.$store.commit('corporate/setInvoiceCurrentPage', 0)

      this.getInvoices()
    },
    getInvoices () {
      let self = this
      if (self.loading || !self.corporateId) { return }

      self.loading = true
      ApiInvoice.getInvoices(self, self.corporateId, res => {
        self.loading = false
      })
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY'); },
    closeInvoice () {
      this.invoiceModal.showModal = false
      this.invoiceModal.showZeroResults = false
    },
    createInvoice () {
      if (this.invoiceLoading) { return }

      let hasError = false
      for (let field in this.invoiceModal.error) {
        if (this.invoiceModal[field] === '') {
          this.invoiceModal.error[field] = 'This field cannot be empty.'
          hasError = true
        }
      }

      if (hasError) { return }

      let from = moment(this.invoiceModal.dateFrom)
      let to = moment(this.invoiceModal.dateTo)
      if (from.format('x') > to.format('x')) {
        this.invoiceModal.error.dateFrom = 'Invalid date range'
        this.invoiceModal.error.dateTo = 'Invalid date range'
        return
      }

      this.$store.commit('corporate/setInvoiceDateFrom', moment(this.invoiceModal.dateFrom).format('MM/DD/YYYY'))
      this.$store.commit('corporate/setInvoiceDateTo', moment(this.invoiceModal.dateTo).format('MM/DD/YYYY'))
      this.$store.commit('corporate/setInvoiceDueDate', moment(this.invoiceModal.dueDate).format('MM/DD/YYYY'))

      this.invoiceModal.showZeroResults = false
      if (this.$refs.invoice.buildTable()) {
        this.$refs.invoice.buildTable()
      }
    },
    zeroResults () { this.invoiceModal.showZeroResults = true },
    closeRespondModal () {
      this.respond.show = false
      if (this.respond.success) {
        this.getCards()
      }
    },
    createInvoiceSuccess (res) {
      this.closeInvoice()
      if (res.error) {
        this.respond = {
          show: true,
          success: false,
          label: 'Oops! something went wrong.',
          message: res.error.message
        }
        return
      }

      this.init()
    }
  },
  watch: {
    corporateId: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.list-box{
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  max-height: calc(100vh - 150px);
  margin-top: 20px;

  table{ margin-top: 0; }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 15px 25px;
    background: #fff;
    text-align: center;
    border-radius: 6px;
    margin-left: -200px;
    margin-top: -180px;
    box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
    display: none;

    &.upload{
      top: 50%;
      width: 900px;
      height: 550px;
      margin-top: -265px;
      margin-left: -450px;

    }
  }
  &.show{
    display: block;

    .modal-content{
      display: block;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
  .header{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #606060;
  }
  .has-error{
    color: #f00;
    background: #ffefef;
    border: 1px solid #f00;
    margin-bottom: 10px;
    border-radius: 2px;
    font-size: 15px;
    line-height: 1.6;
  }
  .close{
    display: block;
    margin-top: 5px;
    font-size: 14px;
    color: #999;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
      color: #555;
    }
  }
}

.data-field{
  padding: 5px;
  position: relative;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    padding: 5px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.invoice-box{
  width: 500px;

  .row{ margin-bottom: 20px; }
  .data-field{
    margin-bottom: 10px;
    text-align: left;
  }
}

.padding-R-s{ padding-right: 5px; }
.padding-L-s{ padding-left: 5px; }
.margin-B-m{ margin-bottom: 10px; }
.margin-T-l{ margin-top: 20px; }

.respond-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: rgba(0,0,0, .5);
  display: table;

  .vertical-center{
    display: table-cell;
    vertical-align: middle;
  }
  .card{
    width: 80%;
    max-width: 500px;
    margin: 0 auto;
    padding: 15px;
    text-align: center;
  }
  .fa-check-circle, .fa-times-circle{
    font-size: 100px;
    color: #26d97a;
    margin-bottom: 5px;
  }
  .fa-times-circle{ color: #F20D0D; }
  .label{
    font-weight: 600;
    color: #505050;
  }
  .success .label{ padding: 0 40px; }
  .message{
    font-size: 14px;
    color: #777;
    margin: 10px 0;
  }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

.status{
  font-size: 12px;
  padding: 2px 6px;
  color: #fff;
  background:#777;
  display: inline-block;
  text-transform: uppercase;
  border-radius: 2px;

  &.unpaid{ background: #de5050; }
  &.paid{ background: #47bd63; }
}

@media only screen and (max-width: 430px) {
  .list-box {
    display: none;
  }

  .modal.show {
    display: flex;
    justify-content: center;
    align-items: center;
    .invoice-box {
      position: unset;
      margin-left: 0;
      margin-top: -30px;
      width: 90%;

      .padding-L-s, .padding-R-s {
        padding: 0;
      }
    }
  }


  .cards-mobile {
    display: block;
    margin-top: 50px;
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      display: flex;
      flex-direction: column;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
        width: 100%;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    
        .time {
          font-size: 12px;
          color: #777;
          word-spacing: 5px;
        }

        .amount {
          font-weight: 900;
          font-size: 20px;
          a {
            text-decoration: none;
          }
        }
      }

      .credit-card {
        font-weight: 900;
      }

      .btn-action {
        display: flex;
        justify-content: center;
        padding: 20px 10px 0;
        a {
          width: 50%;
        }
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        &.pkg-div {
          justify-content: space-between;
        }

        .pkg-type {
          display: flex;
        }

        input {
          margin-right: 5px;
        }

        &.view {
          justify-content: space-between;
          padding-top: 7px;
          padding-bottom: 5px;
          border-top: 1px solid #eee;
        }

        .refer {
          display: flex;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/InvoiceList.vue